export const FINAL_SCREENING_STATUS = {
  APPROVED: 'Approved',
  APPROVED_WITH_CONDITIONS: 'Approved with conditions',
  DECLINED: 'Declined',
};
